const ru = {
  kicker: "Для местного бизнеса и владельцев домов",
  title: "Станьте хозяином в Trollfossjakten.",
  lead: "Хозяин — это местный бизнес или владелец дома вдоль маршрута между Lavangen и Årstein (Gratangen): кафе, ферма, домик, B&B, сауна или магазин. Хозяева встречают гостей игры и принимают к оплате Тролль-кроны (TK) — собственную валюту игры.",
  badges: ["Бесплатно", "Около 2 минут", "Сразу на карте"],
  waysKicker: "Два способа участвовать",
  waysTitle: "Выберите один — или оба.",
  ways: [
    { title: "Место хозяина", tag: "Принимает Тролль-кроны", body: "Вы появляетесь на карте, и гости могут платить вам TK из своего кошелька." },
    { title: "Пит-стоп", tag: "Только размещение", body: "Метка на карте с вашими услугами: зарядка авто или велосипеда, душ, меню, B&B, кемпинг, Wi-Fi, парковка, туалет и кофе. Бесплатная видимость — без денег." },
  ],
  both: "Можно участвовать обоими способами.",
  joinKicker: "Как стать хозяином",
  joinTitle: "Около 2 минут — и бесплатно.",
  steps: ["Скачайте приложение и войдите.", "Откройте Профиль → Стать хозяином → Зарегистрироваться как хозяин.", "Заполните данные (см. список).", "Готово — вы сразу появляетесь на карте."],
  formTitle: "Что нужно заполнить",
  fields: [["Название бизнеса", "обязательно"], ["Адрес", "обязательно"], ["Телефон", "необязательно"], ["Что вы предлагаете", "например, «кофе, вафли, сауна»"]],
  amenitiesTitle: "Ваши удобства",
  noWait: "Без ожидания одобрения и без платы за регистрацию.",
  pitTitle: "Как добавить пит-стоп",
  pitBody: "Откройте Профиль → Открыть пит-стоп → Зарегистрировать пит-стоп и укажите название, адрес, телефон, место на карте и удобства.",
  tkKicker: "Как работают Тролль-кроны",
  tkTitle: "1 TK = 1 NOK.",
  tkEarnTitle: "Гости получают TK, когда",
  tkEarn: ["приглашают друзей — им возвращается 50 % от первой покупки пропуска другом", "получают бонусы ранга Arrow Hunter: +10 / +25 / +100 TK", "крутят колесо призов"],
  tkRule: "TK можно тратить только у зарегистрированных хозяев. Гости не могут вывести их деньгами.",
  payKicker: "Приём оплаты",
  payTitle: "Панель хозяина всё посчитает.",
  paySteps: ["Гость открывает Профиль → Показать мой QR для оплаты.", "Вы сканируете его или вводите код кошелька (TK-XXXXXX).", "Введите сумму в кронах и что куплено, например «кофе и вафли».", "Приложение списывает максимум с баланса TK и показывает остаток к оплате наличными или картой."],
  exampleTitle: "Пример",
  example: { note: "Покупка на 85 kr, в кошельке 60 TK", total: "Покупка", tk: "Оплачено TK", rest: "К оплате наличными или картой" },
  dashboard: "В панели видны все продажи, а также TK, полученные сегодня и всего.",
  ctaTitle: "Готовы принимать гостей игры?",
  ctaBody: "Скачайте приложение, войдите и зарегистрируйтесь как хозяин — это займёт около двух минут.",
  cta: "Скачать приложение",
  ctaPartner: "Хотите и своих троллей? Смотрите партнёрские пакеты",
  ctaHost: "Зарегистрироваться как хозяин",
  webNote: "Удобнее через сайт? Зарегистрируйтесь здесь — отметьте место на карте, расскажите, что предлагаете, и отметьте удобства.",
};

export default ru;
